module.exports = __webpack_public_path__ + "static/media/QRCode.4327e58d.png";